import styled from 'styled-components';

import { media } from 'helpers/breakpoints';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 50px 1fr;
  align-items: center;
  grid-gap: 4px;
`;

const AdViewsText = styled.p`
  ${({ theme }) => theme.fontSize.B12};
`;

const BarWrapper = styled.div<{ arrayLength: number }>`
  margin-top: 2px;
  display: grid;
  grid-template-columns: repeat(
    ${({ arrayLength }) => arrayLength},
    calc(
      (100% - ${({ arrayLength }) => arrayLength * 2}px) /
        ${({ arrayLength }) => arrayLength}
    )
  );
  column-gap: 2px;

  ${media.large} {
    width: 100%;
  }
`;

type TAdViewsBar = { position: number; strength: number };
const Bar = styled.div<TAdViewsBar>`
  height: 4px;
  border-radius: 2px;
  width: 100%;
  ${({ theme, position, strength }) => {
    switch (position) {
      case 1:
        return strength < 2
          ? `background-color: ${theme.colors.ORANGE_LIGHT};`
          : `background-color: ${theme.colors.GREEN_LIGHT};`;
      case 2:
        return strength < 2
          ? `background-color: ${theme.colors.GREY_LIGHT};`
          : `background-color: ${theme.colors.GREEN_LIGHT};`;
      case 3:
        return strength < 3
          ? `background-color: ${theme.colors.GREY_LIGHT};`
          : `background-color: ${theme.colors.GREEN_LIGHT};`;
      case 4:
        return strength < 4
          ? `background-color: ${theme.colors.GREY_LIGHT};`
          : `background-color: ${theme.colors.GREEN_LIGHT};`;
      case 5:
        return strength < 5
          ? `background-color: ${theme.colors.GREY_LIGHT};`
          : `background-color: ${theme.colors.GREEN_LIGHT};`;
      default:
        return `background-color: ${theme.colors.GREY_LIGHT};`;
    }
  }}
`;

export interface IPowerBars {
  strength: number;
  className?: string;
  arrayLength?: number;
}

function PowerBars({ strength, className, arrayLength = 3 }: IPowerBars) {
  return (
    <Wrapper className={className}>
      <AdViewsText>Ad Views</AdViewsText>
      <BarWrapper arrayLength={arrayLength}>
        {Array.from({ length: arrayLength }, (_, index) => index + 1).map(
          (index) => (
            <Bar key={index} position={index} strength={strength} />
          ),
        )}
      </BarWrapper>
    </Wrapper>
  );
}

export { PowerBars };
